export var MPARequestStatus;
(function (MPARequestStatus) {
    MPARequestStatus["MPA_REQUEST_STATUS_CREATED"] = "CREATED";
    MPARequestStatus["MPA_REQUEST_STATUS_PENDING_APPROVAL"] = "PENDING_APPROVAL";
    MPARequestStatus["MPA_REQUEST_STATUS_APPROVED"] = "APPROVED";
    MPARequestStatus["MPA_REQUEST_STATUS_DENIED"] = "DENIED";
    MPARequestStatus["MPA_REQUEST_STATUS_EXPIRED"] = "EXPIRED";
    MPARequestStatus["MPA_REQUEST_STATUS_EXPIRED_PENDING_APPROVAL"] = "EXPIRED_PENDING_APPROVAL";
    MPARequestStatus["MPA_REQUEST_STATUS_EXPIRED_APPROVED"] = "EXPIRED_APPROVED";
    MPARequestStatus["MPA_REQUEST_STATUS_EXECUTED"] = "EXECUTED";
    MPARequestStatus["MPA_REQUEST_STATUS_CANCELLED"] = "CANCELLED";
    MPARequestStatus["MPA_REQUEST_STATUS_CANCELLED_PENDING_APPROVAL"] = "CANCELLED_PENDING_APPROVAL";
    MPARequestStatus["MPA_REQUEST_STATUS_CANCELLED_APPROVED"] = "CANCELLED_APPROVED";
    MPARequestStatus["MPA_REQUEST_STATUS_DISCARDED"] = "DISCARDED";
})(MPARequestStatus || (MPARequestStatus = {}));
